type GmtEvents = 'user_identify'
type GtmVariables = 'userEmail' | 'userName'

declare const window: Window & {
  dataLayer?: object[]
}

export function pushGtmEvent(
  event: GmtEvents,
  props: Partial<Record<GtmVariables, string>> = {},
) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event,
      ...props,
    })
  }
}
